import { redirectTo, RouteComponentProps } from '@reach/router';
import React, { useEffect } from 'react';
import { Layout } from '../components';
import OrderContainer from '../containers/order-container';
import { AddOrderProvider } from '../context/add-order-context';
import { OrderFormProvider } from '../context/order-form-context';
import { ProviderProvider } from '../context/provider-context';
import { getToken } from '../lib/storage-util';

const OrderTemplate: React.FC<RouteComponentProps> = ({ location }: RouteComponentProps) => {
  useEffect(() => {
    document.title = 'Sales Mediamyynti - Order Template';
    const token = getToken();
    if (!token) {
      redirectTo('/');
    }
  }, []);
  const { state = { singleCampaign: null } } = location as any;
  const campaign = state.singleCampaign;
  return (
    <Layout tab="/order">
      <OrderFormProvider>
        <AddOrderProvider>
          <ProviderProvider>
            <OrderContainer campaignData={campaign}></OrderContainer>
          </ProviderProvider>
        </AddOrderProvider>
      </OrderFormProvider>
    </Layout>
  );
};
export default OrderTemplate;
